import { useEffect, useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import GuestConsultation from './pages/GuestConsultation';
import GuestNotaryService from './pages/GuestNotaryService';
import VirtualCourt from './pages/VirtualCourt';
import VirtualCourtLanding from './pages/VirtualCourtLanding';
import ArbitratorPanel from './pages/ArbitratorPanel';
import AdminDashboard from './pages/AdminDashboard';
import LawyerDashboard from './pages/LawyerDashboard';
import ClientDashboard from './pages/ClientDashboard';
import ClientPortal from './pages/ClientPortal';
import ClientRequests from './pages/ClientRequests';
import ClientRequestsAdmin from './pages/ClientRequestsAdmin';
import EmployeeClientRequests from './pages/EmployeeClientRequests';
import Cases from './pages/Cases';
import Appointments from './pages/Appointments';
import Invoices from './pages/Invoices';
import Consultations from './pages/Consultations';
import Documents from './pages/Documents';
import Clients from './pages/Clients';
import CreateUser from './pages/CreateUser';
import Employees from './pages/Employees';
import EmployeesManagement from './pages/EmployeesManagement';
import Assignments from './pages/Assignments';
import ChangePassword from './pages/ChangePassword';
import Fees from './pages/Fees';
import Vouchers from './pages/Vouchers';
import FinancialReports from './pages/FinancialReports';
import Meetings from './pages/Meetings';
import Attendance from './pages/Attendance';
import Reports from './pages/Reports';
import CasesTable from './pages/CasesTable';
import WorkScheduleSettings from './pages/WorkScheduleSettings';
import LegalLibrary from './pages/LegalLibrary';
import LegalAI from './pages/LegalAI';
import MyAssignedTasks from './pages/MyAssignedTasks';
import TaskReports from './pages/TaskReports';
import WorkScheduleTables from './pages/WorkScheduleTablesNew';
import EmailInbox from './pages/EmailInbox';
import MarketerDashboard from './pages/MarketerDashboard';
import EmployeeScheduleManagement from './pages/EmployeeScheduleManagement';
import AccountSettings from './pages/AccountSettings';
import VideoMeetings from './pages/VideoMeetings';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <LanguageProvider>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/guest-consultation" element={<GuestConsultation />} />
          <Route path="/guest-notary" element={<GuestNotaryService />} />
          <Route path="/virtual-court" element={<VirtualCourtLanding />} />
          <Route path="/virtual-court-legacy" element={<VirtualCourt />} />
          <Route path="/virtual-court/arbitrator-panel" element={<ArbitratorPanel />} />
          <Route path="/virtual-court/courtroom" element={<VirtualCourt />} />
          <Route path="/virtual-court/prosecutor" element={<VirtualCourt />} />
          <Route path="/virtual-court/litigation" element={<VirtualCourt />} />
          <Route path="/virtual-court/training" element={<VirtualCourt />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardRouter />
              </PrivateRoute>
            }
          />
          <Route
            path="/cases"
            element={
              <PrivateRoute>
                <Cases />
              </PrivateRoute>
            }
          />
          <Route
            path="/appointments"
            element={
              <PrivateRoute>
                <Appointments />
              </PrivateRoute>
            }
          />
          <Route
            path="/invoices"
            element={
              <PrivateRoute>
                <Invoices />
              </PrivateRoute>
            }
          />
          <Route
            path="/consultations"
            element={
              <PrivateRoute>
                <Consultations />
              </PrivateRoute>
            }
          />
          <Route
            path="/documents"
            element={
              <PrivateRoute>
                <Documents />
              </PrivateRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <PrivateRoute>
                <Clients />
              </PrivateRoute>
            }
          />
          <Route
            path="/client-requests"
            element={
              <PrivateRoute>
                <ClientRequests />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/client-requests"
            element={
              <PrivateRoute>
                <ClientRequestsAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/employee/client-requests"
            element={
              <PrivateRoute>
                <EmployeeClientRequests />
              </PrivateRoute>
            }
          />
          <Route
            path="/create-user"
            element={
              <PrivateRoute>
                <CreateUser />
              </PrivateRoute>
            }
          />
          <Route
            path="/employees"
            element={
              <PrivateRoute>
                <EmployeesManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/employee-schedule"
            element={
              <PrivateRoute>
                <EmployeeScheduleManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/assignments"
            element={
              <PrivateRoute>
                <Assignments />
              </PrivateRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <PrivateRoute>
                <ChangePassword />
              </PrivateRoute>
            }
          />
          <Route
            path="/attendance"
            element={
              <PrivateRoute>
                <Attendance />
              </PrivateRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <PrivateRoute>
                <Reports />
              </PrivateRoute>
            }
          />
          <Route
            path="/cases-table"
            element={
              <PrivateRoute>
                <CasesTable />
              </PrivateRoute>
            }
          />
          <Route
            path="/work-schedule"
            element={
              <PrivateRoute>
                <WorkScheduleSettings />
              </PrivateRoute>
            }
          />
          <Route
            path="/meetings"
            element={
              <PrivateRoute>
                <Meetings />
              </PrivateRoute>
            }
          />
          <Route
            path="/fees"
            element={
              <PrivateRoute>
                <Fees />
              </PrivateRoute>
            }
          />
          <Route
            path="/vouchers"
            element={
              <PrivateRoute>
                <Vouchers />
              </PrivateRoute>
            }
          />
          <Route
            path="/financial-reports"
            element={
              <PrivateRoute>
                <FinancialReports />
              </PrivateRoute>
            }
          />
          <Route
            path="/client-portal"
            element={
              <PrivateRoute>
                <ClientPortal />
              </PrivateRoute>
            }
          />
          <Route
            path="/legal-library"
            element={
              <PrivateRoute>
                <LegalLibrary />
              </PrivateRoute>
            }
          />
          <Route
            path="/legal-library/ai"
            element={
              <PrivateRoute>
                <LegalAI />
              </PrivateRoute>
            }
          />
          <Route
            path="/my-tasks"
            element={
              <PrivateRoute>
                <MyAssignedTasks />
              </PrivateRoute>
            }
          />
          <Route
            path="/task-reports"
            element={
              <PrivateRoute>
                <TaskReports />
              </PrivateRoute>
            }
          />
          <Route
            path="/work-schedules"
            element={
              <PrivateRoute>
                <WorkScheduleTables />
              </PrivateRoute>
            }
          />
          <Route
            path="/emails/*"
            element={
              <PrivateRoute>
                <EmailInbox />
              </PrivateRoute>
            }
          />
          <Route
            path="/marketer"
            element={
              <PrivateRoute>
                <MarketerDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/account-settings"
            element={
              <PrivateRoute>
                <AccountSettings />
              </PrivateRoute>
            }
          />
          <Route
            path="/video-meetings"
            element={
              <PrivateRoute>
                <VideoMeetings />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
    </LanguageProvider>
  );
}

function DashboardRouter() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const userData = JSON.parse(userStr);
      setUser(userData);
      
      if (userData.first_login) {
        navigate('/change-password');
      }
    }
  }, [navigate]);

  if (!user) return null;

  if (user.role === 'admin') {
    return <AdminDashboard />;
  } else if (user.role === 'marketer') {
    return <MarketerDashboard />;
  } else if (user.role === 'lawyer' || user.role === 'accountant' || user.role === 'staff') {
    return <LawyerDashboard />;
  } else {
    // العميل يُحول لبوابة العميل
    return <ClientPortal />;
  }
}

export default App;
